export {
  ComplianceJurisdictionSchema,
  type ComplianceJurisdiction,
  OutreachChannelSchema,
  type OutreachChannel,
  DeliveryAdapterSchema,
  type DeliveryAdapter,
  EnrichmentConfigSchema,
  type EnrichmentConfig,
  ScoringRuleSchema,
  type ScoringRule,
  ScoringConfigSchema,
  type ScoringConfig,
  SequenceStepSchema,
  type SequenceStep,
  SequenceSchema,
  type Sequence,
  RateLimitSchema,
  type RateLimit,
  OutreachConfigSchema,
  type OutreachConfig,
  FirstMessageConfigSchema,
  type FirstMessageConfig,
  type FirstMessageLead,
  FirstMessageVariantSchema,
  type FirstMessageVariant,
  FirstMessageExperimentSchema,
  type FirstMessageExperiment,
  ComplianceConfigSchema,
  type ComplianceConfig,
  DeliveryConfigSchema,
  type DeliveryConfig,
  QualificationGateSchema,
  type QualificationGate,
  DeliveryPrerequisitesSchema,
  type DeliveryPrerequisites,
  TrustSignalSchema,
  type TrustSignal,
  LandingThemeSchema,
  type LandingTheme,
  LandingPageConfigSchema,
  type LandingPageConfig,
  VerticalConfigSchema,
  type VerticalConfig,
  VerticalBrandingSchema,
  type VerticalBranding,
  VerticalEmailConfigSchema,
  type VerticalEmailConfig,
  type FormFieldDescriptor,
  zodToFormFields,
  formFieldsToZodSchema,
} from './types/vertical';

export {
  LeadStatusSchema,
  type LeadStatus,
  LeadSourceSchema,
  type LeadSource,
  LeadSchema,
  type Lead,
  CreateLeadSchema,
  type CreateLead,
  InteractionTypeSchema,
  type InteractionType,
  LeadInteractionSchema,
  type LeadInteraction,
  VALID_TRANSITIONS,
  isValidTransition,
} from './types/lead';

export {
  VideoAssetSchema,
  type VideoAsset,
  ImageAssetSchema,
  type ImageAsset,
  MediaSlotSchema,
  type MediaSlot,
  TestimonialMediaSchema,
  type TestimonialMedia,
  VerticalMediaSchema,
  type VerticalMedia,
} from './types/media';

export { hashLeadId, pickWeightedVariant } from './lib/experiment-assignment';
export { normalizeEmail, correctEmailDomain } from './utils/email';
export { normalizePhone, isValidE164 } from './utils/phone';
export { normalizeName, splitFullName, coerceNameInput } from './utils/name';

export type { Result } from './types/result';

// -----------------------------------------------------------------------
// Server-only modules are NOT re-exported here to avoid pulling
// 'server-only' into client component bundles via the barrel.
// Import them directly from their subpath exports instead:
//
//   @selenos/leads/queries        → createLeadQueries
//   @selenos/leads/service        → createLeadService
//   @selenos/leads/job-types      → JobType, payload types
//   @selenos/leads/job-queue      → enqueueJob, dequeueJobs, etc.
//   @selenos/leads/job-handlers   → handleLeadProcess
//   @selenos/leads/posthog        → getPostHogClient
//   @selenos/leads/vertical-registry → registerVertical, etc.
//   @selenos/leads/lead-capture   → captureLead
// -----------------------------------------------------------------------

export {
  JobType,
  type LeadProcessPayload,
  type OutreachStepPayload,
  type DeliveryPayload,
  type DeliveryBatchPayload,
  type BillingReportUsagePayload,
  type BillingReportActivationPayload,
  type JobPayloadMap,
} from './lib/job-types';
// NonRetriableJobError is in job-handlers which transitively imports server-only.
// Import from @selenos/leads/job-handlers directly.

export {
  registerVertical,
  getVerticalConfig,
  getAllVerticalSlugs,
} from './lib/vertical-registry';

export {
  getEmailContext,
  buildOptOutToken,
  verifyOptOutToken,
  EmailContextError,
  type ResolvedEmailContext,
  type GetEmailContextOpts,
} from './lib/email-context';

// csv-import, list-health, routing-engine contain `import 'server-only'`
// Import from their subpath exports directly:
//   @selenos/leads/csv-import      → importCSV, parseCSVString, ImportConfigSchema
//   @selenos/leads/list-health     → generateListHealthReport, segmentLeads
//   @selenos/leads/routing-engine  → determineRoutingTier, roundRobinAssign, routeLead
